import NormalizeMouseEvent from "./mouse.js";

const Mouse = {
  NormalizeMouseEvent
};

const Input = {
  Mouse
};

export default Input;
